import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'

/**
 * Updates the profile state slice in redux from the specified Session model.
 * @param {Backbone.Model} session Session model
 */
export function updateProfileFromSessionModel (session, force = false) {
  const state = store.getState()
  if (force || (session.user.id && session.user.id === state[profileSlice.name].user?.id)) {
    console.log('Skipping updateProfileFromSessionModel')
    return
  }

  const user = session.user?.attributes
  const participant = session.participant?.attributes

  // Make sure to use copies of the objects.
  const profileState = {
    account: { ...user?.account },
    participant: { ...participant },
    user: { ...user }
  }

  // Clean up redundant or unserializable parts before dispatching the update.
  delete profileState.participant.groups
  delete profileState.user.account
  store.dispatch(profileSlice.manuallyUpdated(profileState))
}

export function updateSessionModelFromProfile (session) {
  const state = store.getState()
  const user = { ...state[profileSlice.name].user }
  const participant = { ...state[profileSlice.name].participant }
  if (state[profileSlice.name].account) {
    user.account = { ...state[profileSlice.name].account }
  }

  if (!participant.id) {
    session.user?.clear()
    session.participant?.clear()
    session._started = null
  } else {
    session.user?.set(user, { parse: true })
    session.participant?.set(participant, { parse: true })
    session._stopped = null
  }
}
